module.exports = __webpack_public_path__ + "static/media/google_play.10778222.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/google_play.svg
// module id = 1242
// module chunks = 0